import firebase from "firebase/app";
import "firebase/analytics";

const config = {
	apiKey: "AIzaSyAymvF9bzDgqeTor1M5jY8WiF7kRDjHgtY",
	authDomain: "felixmobile.firebaseapp.com",
	databaseURL: "https://felixmobile.firebaseio.com",
	projectId: "felixmobile",
	storageBucket: "felixmobile.appspot.com",
	messagingSenderId: "704406233805",
	appId: "1:704406233805:web:a60a4c57fc0438935cbf84",
	measurementId: "G-49D9RN091M",
};

let instance = null;

export default function getFirebase() {
	if (typeof window !== "undefined") {
		if (instance) return instance;
		instance = firebase.initializeApp(config);
		firebase.analytics();
		return instance;
	}

	return null;
}
